import { coreIconMetadata } from '@atlaskit/icon/metadata';

import { getIconName } from './get-icon-name';
import { type NewCoreIconData } from './types';

// get core icons info as a Promise which returns a Record
export const getCoreIcons: () => Promise<void | {
	[x: string]: NewCoreIconData;
}> = () => {
	return Promise.all(
		Object.keys(coreIconMetadata).map(async (name: string) => {
			const icon = await import(
				/* webpackChunkName: "@atlaskit-internal_[request]" */ `@atlaskit/icon/core/${name}`
			);
			return { name, icon: icon.default };
		}),
	)
		.then((newData) =>
			newData
				.map((icon) => {
					const metadata = coreIconMetadata[icon.name];
					return {
						[icon.name]: {
							key: icon.name,
							keywords: metadata.keywords,
							component: icon.icon,
							componentName: metadata.componentName,
							packageName: metadata.package,
							iconName: getIconName(icon.name),
							categorization: metadata.categorization,
							usage: metadata.usage,
							team: metadata.team,
							status: metadata.status,
							replacement: metadata.replacement,
							shouldRecommendSmallIcon: metadata.shouldRecommendSmallIcon,
						} as NewCoreIconData,
					};
				})
				.reduce((acc, b) => ({ ...acc, ...b })),
		)
		.catch((error) => {
			// eslint-disable-next-line no-console
			console.error(error);
		});
};
